export default () => {
    let $menuOpenBtn = $('.menu__button');
    let $menuCloseBtn = $('.menu__close');
    let $menuList = $('.menu__list-wrapper');
    let $pageIndex = $('.page');
    let blackTheme = false;
    
    if($menuOpenBtn.length) {
        $menuOpenBtn.on('click', function () {
            $menuList.addClass('menu__list-wrapper_open');
            if($pageIndex.hasClass('page_menu_open')) {
                blackTheme = true;
            } else {
                $pageIndex.addClass('page_menu_open');
                blackTheme = false;
            }
        });
    }

    if($menuCloseBtn.length) {
        $menuCloseBtn.on('click', function () {
            $menuList.removeClass('menu__list-wrapper_open');
            if(!blackTheme) {
                $pageIndex.removeClass('page_menu_open');
            }
        });
    }

    // This functional temporally off
    // if($menuList.length) {
    //     let $pageIndexBlack = $('.page_index-page_black');
    //
    //     $('.menu__link_about').on('click', function () {
    //         $.fn.fullpage.moveTo('mainSection', '0');
    //         closeMenu();
    //         $pageIndexBlack.removeClass('page_black');
    //     });
    //
    //     $('.menu__link_services').on('click', function () {
    //         $.fn.fullpage.moveTo('mainSection', '1');
    //         closeMenu();
    //         $pageIndexBlack.removeClass('page_black');
    //     });
    //
    //     $('.menu__link_projects').on('click', function () {
    //         $.fn.fullpage.moveTo('mainSection', '2');
    //         closeMenu();
    //     });
    //
    //     $('.menu__link_news').on('click', function () {
    //         $.fn.fullpage.moveTo('mainSection', '3');
    //         closeMenu();
    //     });
    //
    //     $('.menu__link_contacts').on('click', function () {
    //         $.fn.fullpage.moveTo('mainSection', '4');
    //         closeMenu();
    //     });
    //
    //     function closeMenu() {
    //         $pageIndex.removeClass('page_menu_open');
    //         $('.menu__list-wrapper').removeClass('menu__list-wrapper_open');
    //     }
    // }
};


// WEBPACK FOOTER //
// ./templates/bazis/assets/js/jQueryApplication/components/menu.js